/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const GenderEnum = {
    Male: 'Male',
    Female: 'Female',
    Unknown: 'Unknown'
} as const;
export type GenderEnum = typeof GenderEnum[keyof typeof GenderEnum];


export function instanceOfGenderEnum(value: any): boolean {
    for (const key in GenderEnum) {
        if (Object.prototype.hasOwnProperty.call(GenderEnum, key)) {
            if (GenderEnum[key as keyof typeof GenderEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function GenderEnumFromJSON(json: any): GenderEnum {
    return GenderEnumFromJSONTyped(json, false);
}

export function GenderEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): GenderEnum {
    return json as GenderEnum;
}

export function GenderEnumToJSON(value?: GenderEnum | null): any {
    return value as any;
}

export function GenderEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): GenderEnum {
    return value as GenderEnum;
}

